require('../styles/modules/goal.scss');
import React, { Component, PropTypes } from 'react'

class Goal extends Component {
  normalize(number) {
    return Math.round(number/25*this.props.size)
  }

  getContainerStyle() {
    let style = {}
    const { goal, size } = this.props
    if(goal){
      style.top = (size * goal[0] -1 )+'px'
      style.left = (size * goal[1] - this.normalize(7))+'px'
    }
    return style
  }

  getGoalStyle() {
    let style = {}
    const { color } = this.props
    color && (style.color = this.colorMap(color))
    color && (style.backgroundColor = this.backgroundcolorMap(color))
    return style
  }

  render() {
    return (
      <div className = 'goal-container' style = { this.getContainerStyle() }>
        <div className = 'goal'>
          <i className="fa fa-star" aria-hidden="true" style = { this.getGoalStyle() }></i>
        </div>
      </div>
    )
  }
}

Goal.prototype.colorMap = function(color){
  var map = {
    red: 'pink',
    blue: 'darkblue',
    yellow: '#FCFF1F',
    green: 'lightgreen',
  } 
  return map[color]
}

Goal.prototype.backgroundcolorMap = function(color){
  var map = {
    red: 'red',
    blue: '#5555ff',
    yellow: 'darkorange',
    green: '#008E00',
  } 
  return map[color]
}

export default Goal



// WEBPACK FOOTER //
// ./components/Goal.js